import axios from 'axios'

const util = require('../../util.js')

const default_filter = {
  user: null,
  organization: null,
  source: null,
  primaryRole: null,
  additionalRoles: [],
  active: true,
}

const default_paging = {
  currentPage: 1,
  perPage: 25,
  perPageAlternatives: [25, 50, 100, 1000],
  totalRows: 0
}
const state = {
  user: {
    userId: undefined,
    username: undefined,
    source: undefined,
    fullName: undefined,
    firstName: undefined,
    lastName: undefined,
    primaryRole: undefined,
    additionalRoles: [],
    preferredLanguage: undefined,
    active: undefined,
    lastLogin: undefined,
    homeOrganization: undefined,
    schoolOrganizations: [],
    email: undefined,
    mobile: undefined,
    expiryDate: undefined,
    created: undefined,
    createdBy: undefined,
    modified: undefined,
    modifiedBy: undefined
  },
  users: [],
  filter: { ...default_filter },
  paging: { ...default_paging },
  userGroups: [],
  events: [],
  isEventShowButtonEnabled: true,
  loading: false,
  createLoading: false,
  leaveOrganization: [],
}

const mutations = {
  UPDATE_USER (state, payload) {
    state.user = payload
    state.users = state.users
      ? state.users.map(user => user.userId === payload.userId ? payload : user)
      : [payload]
  },
  UPDATE_USERS (state, payload) {
    state.users = payload.response
    state.paging.totalRows = payload.resultCount
  },
  UPDATE_FILTER (state, payload) {
    state.filter = payload
  },
  UPDATE_PAGING (state, payload) {
    state.paging = payload
  },
  UPDATE_ORGANIZATION (state, payload) {
    state.filter.organization = payload
  },
  UPDATE_USER_GROUPS (state, payload) {
    state.userGroups = payload
  },
  REMOVE_SCHOOL_ORGANIZATION (state, organizationNumber) {
    let oldSchools = state.user.schoolOrganizations
    state.user.schoolOrganizations = oldSchools.filter(organization => organization.number !== organizationNumber)
  },
  ADD_SCHOOL_ORGANIZATION (state, organization) {
    if (state.user.schoolOrganizations === null) {
      state.user.schoolOrganizations = []
    }
    state.user.schoolOrganizations.push(organization)
  },
  UPDATE_HOME_ORGANIZATION (state, organization) {
    state.user.homeOrganization = organization
  },
  UPDATE_EVENTS (state, payload) {
    state.events = payload
    state.isEventShowButtonEnabled = false
  },
  UPDATE_EMPTY_EVENT (state) {
    state.events = null
    state.isEventShowButtonEnabled = true
  },
  UPDATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.loading = payload
  },
  UPDATE_CREATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.createLoading = payload
  },
  UPDATE_USER_ID (state, payload) {
    state.filter.user = payload
  }
}

const actions = {
  async getUsers ({ commit, dispatch }) {
    await dispatch('getSelectedActiveProfile')
    if ((
        (!state.filter.user && !state.filter.organization) ||
        (state.filter.user && state.filter.user.length < 3) ||
        (state.filter.organization && state.filter.organization.length < 3)
      ) &&
      !state.filter.additionalRoles.length > 0
    ) {
      console.log('Ignoring search request as it will fail server validation')
      commit('UPDATE_USERS', [])
      return
    }
    commit('UPDATE_FORM_DISABLE_INDICATOR', true)
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user', {
        params: {
          user: util.emptyToNull(state.filter.user),
          organization: util.emptyToNull(state.filter.organization),
          primaryRole: util.emptyToNull(state.filter.primaryRole),
          additionalRoles: util.addQueryParam(state.filter.additionalRoles, 'additionalRoles'),
          source: util.emptyToNull(state.filter.source),
          active: state.filter.active === true ? true : null,
          pageNumber: util.emptyToNull(state.paging.currentPage),
          pageSize: util.emptyToNull(state.paging.perPage)
        }
      })
      .then((response) => {
        commit('UPDATE_USERS', response.data)
      })
      .finally(() => {
        commit('UPDATE_FORM_DISABLE_INDICATOR', false)
      })
  },
  getUser ({ commit }, userId) {
    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId)
      .then((response) => {
        commit('UPDATE_USER', response.data)
      })
  },
  deleteAtbInfo ({ commit }, userId) {
    axios
      .delete(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId + '/atbinfo')
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId)
      .then((response) => {
        commit('UPDATE_USER', response.data)
      })
  },
  resetFilter ({ commit }) {
    commit('UPDATE_FILTER', { ...default_filter })
    commit('UPDATE_PAGING', { ...default_paging })
    state.users = []
    state.user = {}
  },
  updateOrganization ({ commit }, organization) {
    commit('UPDATE_ORGANIZATION', organization)
  },
  getGroupsByUserId ({ commit }, userId) {
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId + '/groups')
      .then((response) => {
        if (response.data) {
          response.data.forEach(group => {
            let group_cellVariants = {}
            if (!group.active) {
              group_cellVariants.active = 'danger'
            }

            let today = new Date().toISOString().split('T')[0]
            if (group.startDate != null && group.startDate < today && group.endDate != null && group.endDate < today) {
              group_cellVariants.startDate = 'danger'
              group_cellVariants.endDate = 'danger'
            }
            group._cellVariants = { ...group_cellVariants }
          })
        }
        commit('UPDATE_USER_GROUPS', response.data)
      })
  },
  updateUser ({ commit }, userId) {
    commit('UPDATE_FORM_DISABLE_INDICATOR', true)
    return axios
      .put(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId, state.user)
      .then((response) => {
        commit('UPDATE_USER', response.data)
      })
      .finally(() => {
        commit('UPDATE_FORM_DISABLE_INDICATOR', false)
      })
  },
  async create ({ commit }, newUser) {
    commit('UPDATE_CREATE_FORM_DISABLE_INDICATOR', true)
    await axios
      .post(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/', newUser)
      .then((response) => {
        commit('UPDATE_USER', response.data)
      })
      .finally(() => {
        commit('UPDATE_CREATE_FORM_DISABLE_INDICATOR', false)
      })
  },
  removeSchoolOrganization ({ commit }, organizationNumber) {
    commit('REMOVE_SCHOOL_ORGANIZATION', organizationNumber)
  },
  addSchoolOrganization ({ commit }, organization) {
    commit('ADD_SCHOOL_ORGANIZATION', organization)
  },
  updateHomeOrganization ({ commit }, organization) {
    commit('UPDATE_HOME_ORGANIZATION', organization)
  },
  getObjectReference ({ dispatch, commit }, objectReference) {
    return dispatch('events/getObjectReference', { objectReference: objectReference }, { root: true })
      .then((response) => {
          if (response.length > 0) {
            commit('UPDATE_EVENTS', response)
          } else {
            commit('UPDATE_EMPTY_EVENT')
          }
        }
      )
  },
  async getFullName (state, { userIds }) {
    const params = new URLSearchParams()
    Array.from(userIds).forEach(userId => params.append('userId', userId))
    const coreResponse = await axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user', {
        params: params
      })

    let users = coreResponse.data.response

    const userIdsFound = users.map(user => user.userId)
    let userIdsNotFound = Array.from(userIds).filter(userId => !userIdsFound.includes(userId))

    let map = new Map()
    users.forEach(user => {
      map.set(user.userId, user.fullName)
    })

    userIdsNotFound.forEach(userId => {
      map.set(userId, null)
    })
    return map
  },
  getSelectedActiveProfile ({ commit, rootGetters }) {
    let isActiveProfileSet = rootGetters['sessionStorage/isActiveProfileSet']
    if (isActiveProfileSet) {
      let activeProfile = rootGetters['sessionStorage/activeProfile']
      if (activeProfile.activeProfileType === 'organization') {
        commit('UPDATE_ORGANIZATION', activeProfile.id)
      } else {
        commit('UPDATE_USER_ID', activeProfile.id)
      }
    }
  }
}

const getters = {
  user: state => state.user,
  users: state => state.users,
  filter: state => state.filter,
  paging: state => state.paging,
  userGroups: state => state.userGroups,
  events: state => state.events,
  isEventShowButtonEnabled: state => state.isEventShowButtonEnabled,
  loading: state => state.loading,
  createLoading: state => state.createLoading,
  leaveOrganization: state => state.leaveOrganization,
}

const usersModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default usersModule
